import Client from "../components/Client"
import ClientList from "../components/ClientList"
import Employee from "../components/Employee"
import Dashboard from "../components/Dashboard"
import EmployeeList from "../components/EmployeeList"
import Issue from "../components/Issue"
import IssuesList from "../components/IssueList"
import Login from "../components/Login"
import Page404 from "../components/Page404"
import Project from "../components/Project"
import RequestResetPassword from "../components/RequestResetPassword"
import ResetPassword from "../components/ResetPassword"
import Help from "../components/Help"

export const viewMap = {
    notFound: <Page404 />,
    home: <Dashboard />,
    login: <Login />,
    issues: <IssuesList />,
    issue: <Issue />,
    employees: <EmployeeList />,
    employee: <Employee />,
    project: <Project />,
    docs: <Help />,
    clients: <ClientList />,
    client: <Client />,
    dashboard: <Dashboard />,
    resetpassword: <ResetPassword />,
    requestresetpassword: <RequestResetPassword />,
}
